import { Link } from "react-router-dom";
import { MapPin, BadgeCheck, Package, Crown, Award } from "lucide-react";
import { RatingBlock } from "@/components/Stars";
import { fileUrl } from "@/lib/api";

export const isTopRated = (b) => b.review_avg >= 4.5 && (b.review_count || 0) >= 3;

export const TopRated = ({ large }) => (
  <span className={`inline-flex items-center gap-1 rounded-full bg-[#D97706] font-semibold text-white ${large ? "px-3 py-1 text-xs" : "px-2.5 py-0.5 text-xs"}`} data-testid="top-rated-badge">
    <Award className={large ? "h-3.5 w-3.5" : "h-3 w-3"} />Très bien noté
  </span>
);

export function BusinessCard({ b, index, active, onHover }) {
  const photo = b.photos?.[0];
  return (
    <Link to={`/entreprise/${b.id}`} onMouseEnter={() => onHover?.(b.id)} onMouseLeave={() => onHover?.(null)}
      className={`group flex gap-4 rounded-xl border bg-white p-4 transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-0.5 hover:shadow-lg sm:p-5 ${active ? "border-[#1E40AF] shadow-lg" : "border-slate-200"}`}
      data-testid={`business-card-${b.id}`}>
      <div className="relative hidden h-24 w-24 shrink-0 overflow-hidden rounded-lg bg-slate-100 sm:block">
        {photo ? <img src={fileUrl(photo.url)} alt={b.name} className="h-full w-full object-cover" /> : (
          <span className="grid h-full w-full place-items-center font-display text-3xl font-extrabold text-slate-300">{(b.name || "?")[0]}</span>
        )}
        {index != null && <span className="absolute left-1.5 top-1.5 rounded-md bg-slate-900 px-1.5 text-xs font-bold text-white">{index + 1}</span>}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-start justify-between gap-2">
          <h3 className="truncate font-display text-lg font-bold text-slate-900 group-hover:text-[#1E40AF]" data-testid="business-card-name">{b.name}</h3>
          {b.distance != null && <span className="shrink-0 rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-semibold text-slate-700" data-testid="business-card-distance">{b.distance.toFixed(1)} km</span>}
        </div>
        <p className="mt-0.5 text-sm text-slate-500">{b.naf_label || (b.naf ? `Code NAF ${b.naf}` : b.source === "google" ? "Fiche Google" : "")}</p>
        <div className="mt-2"><RatingBlock b={b} /></div>
        <p className="mt-2 flex items-center gap-1 truncate text-sm text-slate-600"><MapPin className="h-3.5 w-3.5 shrink-0" />{b.address}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {isTopRated(b) && <TopRated />}
          {b.claimed && <span className="inline-flex items-center gap-1 rounded-full bg-[#DCFCE7] px-2.5 py-0.5 text-xs font-semibold text-[#14532D]"><BadgeCheck className="h-3 w-3" />Pro vérifié</span>}
          {b.plan === "pro" && <span className="inline-flex items-center gap-1 rounded-full bg-[#EFF6FF] px-2.5 py-0.5 text-xs font-semibold text-[#1E40AF]"><Crown className="h-3 w-3" />Pro</span>}
          {b.in_stock_count > 0 && <span className="inline-flex items-center gap-1 rounded-full bg-[#FEF3C7] px-2.5 py-0.5 text-xs font-semibold text-[#78350F]"><Package className="h-3 w-3" />{b.in_stock_count} produit(s) en stock</span>}
          {b.siret && <span className="font-mono-id rounded-full border border-slate-200 px-2.5 py-0.5 text-[11px] text-slate-500" data-testid="business-card-siret">SIRET {b.siret}</span>}
          {(b.brands || []).slice(0, 3).map((br) => <span key={br} className="rounded-full border border-slate-200 px-2.5 py-0.5 text-xs text-slate-700">{br}</span>)}
        </div>
      </div>
    </Link>
  );
}
